<form class="geaui-grid-col-12" [formGroup]="addGrantsForm">
  <div class="dialog-body">
    <div class="dialog-field">
      <geaui-select-v2
        [id]="'select'"
        [required]="true"
        [options]="grantOptions"
        [group]="addGrantsForm"
        (selectChanged)="selectChanged($event)"
        label="Grant"
        formName="grant"></geaui-select-v2>
      <div class="mt-6">
        <geaui-multi-select-v3
          [required]="true"
          [options]="targets"
          [formGroupInput]="addGrantsForm"
          [loading]="isTargetLoading()"
          pStyleClass="mt-6"
          label="Target"
          formFieldName="target"></geaui-multi-select-v3>
      </div>
    </div>
  </div>
  <p-divider />
  <div class="p-dialog-footer">
    <geaui-button-v3 class="footer-btn" [type]="'secondary'" [flex]="true" (click)="close()">Cancel</geaui-button-v3>
    <geaui-button-v3
      class="footer-btn"
      [disabled]="!addGrantsForm.valid"
      [flex]="true"
      [sending]="addingGrants()"
      (click)="addGrantsToUser()"
      >Add</geaui-button-v3
    >
  </div>
</form>
